import React, { useState, useRef, useEffect } from "react";
import { KBD } from "../../utils/Keybindings";
import { listen } from "../../hooks/Listener";
import Input from "../../ui/Input";
import Cookies from 'js-cookie';
import Label from "../../ui/Label";
import Card from "../../ui/Card";
import Button from "../../ui/Button";
import Float from "../../ui/Float";
import { apiCall } from "../../utils/Api";
import { showError } from "../../ui/Message";
import { kbdEvent } from "../../utils/Utils";
import { ROUTES } from "../../utils/Routes";
import Login from "./Login";
import Stores from "./Stores";
import Spin from "../../ui/Spin";

export default function Authentication(props) {

    const { controller = "", status = "", setStatus = () => { } } = props;

    const route = ROUTES.AUTHENTICATION.LOGIN;
    const path = window.location.pathname;
    const path_id = path.split("/")[1];
    const work_station_id = path.split("/")[2] ?? null;
    const [session, setSession] = useState();
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState("login");


    const continueToBMO = (_corp_id, _store_name) => {
        setLoading(true);
        window.can_call = true;
        apiCall("account/bizToBmo", { store_id: 298, corp_id: _corp_id }, (_s, _r) => {
            if (_s) {
                window.credentials = {
                    socket_url: "wss://" + _r.url + "/ws/",
                    ticket: _r.ticket,
                    store_id: _corp_id,

                }
                if (work_station_id !== null) {
                    window.history.replaceState(null, '', '/' + _corp_id.toString() + "/" + work_station_id);
                } else {
                    window.history.replaceState(null, '', '/' + _corp_id.toString());
                }

                setStatus("connecting")
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }





    const checkSession = () => {


        window.login_session = session;

        if (session) {
            if (session?.logged_in) {

                // No possible stores
                if (session.available_corps.filter(item => item.can_bmo).length === 0) {
                    showError({ error: "BMO is not currently activated on your account.  Please contact Bookmanager Support to activate." })
                    return;
                }

                // Bypass with path id
                if (path_id && session.available_corps.filter(item => item.can_bmo).find(item => item.id.toString() === path_id.toString())) {
                    continueToBMO(path_id, session.store_name);
                    return;
                }

                else {
                    if (path_id) {
                        showError({ error: "No store with Bookmanager Online access is linked to this account." });
                    }
                }

                // If there is only one store, skip store selection
                if (session.available_corps.filter(item => item.can_bmo).length === 1) {
                    let _f = session.available_corps.find(item => item.can_bmo);
                    continueToBMO(_f.id, session.store_name);
                    return;
                }

                window.bm_state.value = ROUTES.AUTHENTICATION.STORES;
                setState("stores")


            }
        }

    }

    useEffect(checkSession, [session, state])


    const logout = (_store_id = session.store_id) => {
        setLoading(true);
        apiCall("account/logout", { store_id: _store_id }, (_s, _r) => {
            if (_s) {
                setSession(_r);
                setState("login")
                window.bm_state.value = ROUTES.AUTHENTICATION.LOGIN;
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    

    return (
        <Spin loading={loading}>
            <Card style={{ "padding": "10px" }}>
                {(state === "login" && <Login
                    controller={controller}
                    loading={loading} setLoading={setLoading}
                    state={state} setState={setState}
                    session={session} setSession={setSession}
                    route={ROUTES.AUTHENTICATION.LOGIN}
                />)}
                {(session && state === "stores" && <Stores
                    controller={controller}
                    loading={loading} setLoading={setLoading}
                    state={state} setState={setState}
                    session={session} setSession={setSession}
                    route={ROUTES.AUTHENTICATION.STORES}
                    continueToBMO={continueToBMO}
                    logout={logout}
                />)}
            </Card>
        </Spin>
    )
}